const COUPON_SITE_HOSTS = [
    "alivebyscience.worthepenny.com",
    "couponspeak.com",
    "dealspotr.com",
    "joincheckmate.com",
    "renue-by-science.tenereteam.com",
    "renuebyscience.knoji.com",
    "renuebyscience.valuecom.com",
    "renuebyscience.worthepenny.com",
    "renuesciencecoupon.com",
    "scoopcoupons.com",
    "simplycodes.com",
    "usa.promocodie.com",
    "www.coupert.com",
    "www.hotsbuy.com",
    "www.hotdeals.com",
    "www.joinhoney.com",
    "www.nicecodes.org",
    "www.notretailme.com",
    "www.worthepenny.com",
    "www.karmanow.com"
];
const COUPON_SITE_UTM_TAGS = [
    "checkmate",
];

const BRYAN_REFERSION_PATH = '?rfsn=6245639.5be0b4&utm_source=refersion&utm_medium=affiliate&utm_campaign=6245639.5be0b4';
console.log('kwan hit');

if (document.referrer && COUPON_SITE_HOSTS.includes(new URL(document.referrer).host)) {
    console.log('kwan redirect 1');
    window.location.href = window.location.origin + BRYAN_REFERSION_PATH;
} else if (COUPON_SITE_UTM_TAGS.includes(new URL(window.location.href).searchParams.get('utm_source')) || COUPON_SITE_UTM_TAGS.includes(new URL(window.location.href).searchParams.get('utm_campaign'))) {
    console.log('kwan redirect 2');
    window.location.href = window.location.origin + BRYAN_REFERSION_PATH;
}
